import config from '@/config'
import api from '@/api'
import utils from '@/utils'
let o = {}
o.filterArr = function (arr, key, val) {
  let arrs = arr.filter((o) => { // 用户
    return o[key] == val
  })
  return arrs
}
o.createMsgObj = function (val) {
  let users = this.filterArr(val.people, 'uitype', '03')
  let members = this.filterArr(val.people, 'uitype', '02')
  let depts = []
  if (this.filterArr(val.people, 'type', 'all').length > 0) {
    depts = this.filterArr(val.people, 'type', 'all')
  } else {
    depts = this.filterArr(val.people, 'uitype', '01')
  }
  let tags = this.filterArr(val.people, 'tagType', '06')
  let o = {
    title: val.form.title,
    content: val.form.content,
    deptIds: utils.arr2str(utils.grabVal(depts, 'id')),
    memberIds: utils.arr2str(utils.grabVal(members, 'id')),
    userIds: utils.arr2str(utils.grabVal(users, 'id')),
    tagId: utils.arr2str(utils.grabVal(tags, 'id')),
    types: utils.arr2str(val.form.type)
  }
  return o
}
o.sendMsg = function (o) {
  var p = this.createMsgObj(o)
  return new Promise(function (resolve, reject) {
    api.post(config.bylApiPath, '/msg/sendMessage', p, r => {
      resolve(r.data)
    })
  })
}
export default o



// WEBPACK FOOTER //
// ./src/utils/sendMsg.js